import React from "react";
import {TEXT_TYPES} from "../../../constants/APP_CONSTANTS";
import urlHelper from "../../../_helpers/url.format.helper";
import config from "../../../config";
import AxiosClient from "../../../_helpers/http.helper";
import moment from "moment";
import ReactTable from "react-table";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingIndicator from "../../widgets/LoadingIndicator/LoadingIndicator";
import union from "lodash/union";
import ModalDialog from "../../widgets/ModalDialog/ModalDialog";

export default class BatchDetails extends React.Component {

    state = {
        batchDetailList: [],
        selected: {},
        fileName: "Loading..",
        pageSize: 25,
        pageNumber: null,
        totalItems: 0,
        hasMore: true,
        showModal: false,
        message: ""
    };

    componentDidMount() {
        this.loadMore();

        this.getFileName().then(result => {
            this.setState({
                fileName: result.data.metadataIngestionStatus[0].fileName
            });
        }).catch(()=>{
            this.setState({
                fileName: "Error while loading file name"
            });
        });
    }

    getFileName = () => {
        const url = urlHelper.formatUrl(
            config.contentService.baseUrl,
            config.contentService.routes.getBatchDetailsByBatchId
        );
        return AxiosClient.get(url.concat(this.props.match.params.id));
    };

    loadMore = () => {
        this.getBatchDetails().then(results => {
            this.setState(prevState => ({
                batchDetailList: union([
                    ...prevState.batchDetailList,
                    ...results.data.content
                ], 'id'),
                pageNumber: results.data.number,
                totalItems: results.data.totalElements,
                hasMore: !results.data.last
            }));
        });
    };

    getBatchDetails = () => {
        const pageNumber = this.state.pageNumber === null ? 0 : this.state.pageNumber + 1;
        const url = config.contentService.baseUrl+config.contentService.routes.getBatchDetails+this.props.match.params.id+"?pageSize="+this.state.pageSize+"&pageNumber="+pageNumber;
        return AxiosClient.get(url);
    };

    toggleRow = (obj) => {
        const {selected} = this.state;
        const newSelected = Object.assign({}, selected);
        newSelected[obj.id] = !selected[obj.id];
        this.setState({
            selected: newSelected
        });
    };

    selectDeselectAll = (status) => {
        const {batchDetailList} = this.state;
        const newSelected = {};

        if(batchDetailList){
            batchDetailList.map(batch=>{
                if(batch.ingestionStatusType ==="ALREADY_EXISTS"){
                    newSelected[batch.id] = status;
                }
            });
        }

        this.setState({
            selected : newSelected
        });
    };

    closeModal = () => {
        this.setState({
            showModal: false
        });
    };

    replaceMetadata = () => {
        this.setState({
            pageNumber: null,
            selected: {},
        });

        const url = urlHelper.formatUrl(
            config.contentService.baseUrl,
            config.contentService.routes.replaceMetadata
        );
        let idList = this.createPayload();

        if(idList.length === 0){
            return;
        }

        let payload = {
            "metadataIds": idList
        };

        return AxiosClient.post(url,payload).then(() => {
            this.getBatchDetails().then(results => {
                this.setState({
                    batchDetailList:results.data.content,
                    pageNumber: results.data.number,
                    totalItems: results.data.totalElements,
                    hasMore: !results.data.last,
                    showModal: true,
                    message: "Success! Selected records were replaced."
                });
            });
        }).catch(() => {
            this.setState({
                showModal: true,
                message: "Error! Selected records were not replaced."
            });
        });
    };

    createPayload = () => {
        let payload = [];
        let arr = Object.entries(this.state.selected).map(([key,value])=>{
            if(value){
                return key;
            }
        });
        arr.map(id => {
            if(id){
                payload.push(id);
            }
        });
        return payload;
    };

    render() {
        const {showModal,message} = this.state;
        const columns = [
            {
                Header: "Row",
                accessor: "rowNumber",
                sortable: true,
                width: 200
            },
            {
                Header: "Status",
                accessor: "ingestionStatusType",
                sortable: true,
                Cell: (row) => (
                    row.value === "ALREADY_EXISTS" ? "Pending" : row.value === "FAILED" ? "Failed" : row.value === "COMPLETED" ? "Success" : ""
                ),
            },
            {
                Header: "Message",
                accessor: "customMessage",
                sortable: true
            },
            {
                Header: "Time Uploaded",
                id: "startMetadataProcess",
                accessor: d =>
                    moment(d.startMetadataProcess)
                        .utc()
                        .format("MM/DD/YY HH:mm z"),
                sortable: true
            },
            {
                Header: "Time Processed",
                id: "endMetadataProcessed",
                accessor: d =>
                    moment(d.endMetadataProcessed)
                        .utc()
                        .format("MM/DD/YY HH:mm z"),
                sortable: true
            },
            {
                Header: "Replace",
                accessor: "ingestionStatusType",
                sortable: false,
                Cell: (row) => (
                    row.value === "ALREADY_EXISTS" ?
                        <div className="pe-checkbox check-box-center" onClick={() => {
                            this.toggleRow(row.original);
                        }}>
                            <input type="checkbox" id="checkboxInput"
                                checked={!!this.state.selected[row.original.id]} onChange={()=>{}}/>
                            <span>
                                <svg aria-hidden="true" focusable="false" className="pe-icon--check-sm-18">
                                    <use xlinkHref="#check-sm-18"/>
                                </svg>
                            </span>
                        </div> : ""),
            },
        ];
        return (
            <div>
                <label className="pe-page-title--small">
                    {TEXT_TYPES.VIEW_BATCH_DETAILS}
                </label>
                <hr/>
                <div className="pe-row ">
                    <div className="batch-header-container">
                        <div className="batch-file-name">
                            <b>File Name: </b>
                            <label>{this.state.fileName}</label>
                        </div>
                        <div className="batch-buttons">
                            <button className="pe-btn" onClick={()=>{this.selectDeselectAll(true);}}>Select All</button>
                            <button className="pe-btn" onClick={()=>{this.selectDeselectAll(false);}}>Deselect All</button>
                            <button className="pe-btn" onClick={this.replaceMetadata}>Replace Selected Metadata</button>
                        </div>
                    </div>
                </div>
                <div className="pe-row">
                    <div className="pe-col-12 pt-4">
                        {this.state.totalItems > 0 && (
                            <div id="scrollTable" className="infiniteScroll">
                                <InfiniteScroll
                                    dataLength={this.state.batchDetailList
                                        .length}
                                    next={this.loadMore}
                                    hasMore={this.state.hasMore}
                                    loader={<LoadingIndicator/>}
                                    scrollableTarget="scrollTable"
                                >
                                    <div className="table-wrap">
                                        <ReactTable
                                            className="-highlight -striped"
                                            data={this.state.batchDetailList}
                                            showPagination={false}
                                            columns={columns}
                                            defaultPageSize={
                                                this.state.totalItems
                                            }
                                            minRows={0}
                                            sortable={false}
                                            pageText=""
                                            noDataText="No Curated Collection Batches found"
                                            getTrProps={() => {
                                                return {
                                                    style: {
                                                        textAlign: "center",
                                                        display: "inline-flex",
                                                        justifyContent: "center"
                                                    }
                                                };
                                            }}
                                        />
                                    </div>
                                </InfiniteScroll>
                            </div>
                        )}
                    </div>
                </div>
                <ModalDialog title={"Info"} showModal={showModal} showSuccess={false} onCancel={this.closeModal} showCancel={false}>
                    <p>{message}</p>
                </ModalDialog>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/ContentIngestion/BatchDetails.js